<template>
    <div>
        <form id="ng" @submit.stop>
            <template>
                <v-row justify="center">
                    <v-dialog
                            v-model="moreInfo"
                            max-width="600"
                            hide-overlay
                            transition="dialog-bottom-transition"
                    >
                        <v-card>
                            <v-toolbar
                                    flat
                                    dark
                                    color="primary"
                            >

                                <v-toolbar-title>انتخاب سایر ویژگی‌ها و امکانات</v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-toolbar-items>
                                    <v-btn
                                            icon
                                            dark
                                            @click="moreInfo = false"
                                    >
                                        <v-icon>mdi-close</v-icon>
                                    </v-btn>
                                </v-toolbar-items>
                            </v-toolbar>
                            <other_attrs :ui_schema="this.ui_schema" :param="schema.other_options_and_attributes"
                                         :fields="extraField"></other_attrs>
                        </v-card>
                    </v-dialog>
                    <v-dialog
                            v-model="customersDialog"
                            max-width="1200"
                            hide-overlay
                            transition="dialog-bottom-transition"
                    >
                        <v-card>
                            <v-toolbar
                                    flat
                                    dark
                                    color="primary"
                            >

                                <v-toolbar-title>اضافه کردن مشتری جدید</v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-toolbar-items>
                                    <v-btn
                                            icon
                                            dark
                                            @click="customersDialog = false"
                                    >
                                        <v-icon>mdi-close</v-icon>
                                    </v-btn>
                                </v-toolbar-items>
                            </v-toolbar>
                            <new-customer from="newFile" v-if="customersDialog" v-model="newUser"></new-customer>
                        </v-card>
                    </v-dialog>
                </v-row>
            </template>
            <div class="p-0 mt-5 mb-3 pt-5 text-right" style="border: none!important;">
                <v-switch
                        label="فایل قابل ارسال به دیوار"
                        v-model="divarSave"
                        class="col-md-8 mx-auto"
                        color="indigo"
                ></v-switch>
                <category-selector @category-schema="getSchema" @category-fields="getFields"
                                   @category-current="getCurrent" ref="category"
                                   :multiAdsCat="false">
                </category-selector>
                <div class="col-md-11 mx-auto">
                    <div class="col-md-8 mx-auto px-0">
                        <city-selector ref="city" :force="true"></city-selector>
                    </div>
                    <div class="col-md-8 mx-auto px-0">
                        <v-autocomplete outlined dense label="مشتریان" placeholder="نام مشتری مورد نظر را جستجو کنید."
                                        v-model="customer_id"
                                        clearable
                                        clear-icon="mdi-close-circle-outline"
                                        prepend-inner-icon="fa fa-pencil-alt"
                                        :items="customers" item-text="name" item-value="id"
                                        name="city">
                            <template v-slot:prepend-item>
                                <div class="col-md-12">
                                    <v-btn text class="mx-0 px-0" color="indigo" @click="OpenAdd">
                                        <span class="fa fa-plus ml-1"></span>
                                        افزودن مشتری جدید
                                    </v-btn>
                                </div>
                            </template>
                        </v-autocomplete>
                    </div>
                    <div class="col-md-8 mx-auto px-0">
                        <image-uploader :for-new="false"></image-uploader>
                    </div>
                </div>

                <div class="px-5 mx-1">
                    <div v-if="extraField.length >0" class="col-md-8 px-0 mx-auto">
                        <v-btn @click="moreInfo = true" class="mr-6 font-weight-bold cursor-pointer text-white"
                               color="indigo">انتخاب سایر ویژگی‌ها و امکانات
                        </v-btn>
                    </div>

                    <input-maker ref="inputs" :param="schema" :ui_schema="this.ui_schema"
                                 :fields="this.fields"></input-maker>
                    <v-text-field
                            label="کد فایل"
                            dense
                            maxLength="8"
                            counter="8"
                            outlined
                            v-model="fileCode"
                            hint="کد فایل حداکثر ۸ رقم میتواند باشد"
                            class="col-md-8 mx-auto"
                    ></v-text-field>
                </div>
                <!--                    <setting-ads :timeRequire="true"></setting-ads>-->
                <div v-if="divarSave" class="col-md-8 mr-auto">
                    <v-btn  @click="submitAds" class="submit-btn float-left">
                        <span class="fa fa-save ml-1" style="font-size: 1.3rem"></span>
                        ثبت فایل
                    </v-btn>
                </div>
                <div v-else class="col-md-8 mr-auto">
                    <v-btn @click="submitWithoutMOve" class="submit-btn float-left">
                        <span class="fa fa-save ml-1" style="font-size: 1.3rem"></span>
                        ثبت فایل
                    </v-btn>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import TitleRibbon from "../../uiBeautifier/titleRibbon";
import CategorySelector from "../divarDependency/categorySelector";
import CitySelector from "../divarDependency/citySelector";
import PicSelector from "../../uploadCenter/picSelector";
import InputMaker from "../divarDependency/inputMaker";
import {Axios2, Bus} from "../../../../main";
import MoreInfo from "./moreInfo";
import Other_attrs from "../divarDependency/other_attrs";
import ImageUploader from "../../uiBeautifier/imageUploader";
import Uploader from "../../uploadCenter/uploader";
import NewCustomer from "../customer/newCustomer";

export default {
    name: "newEstate",
    components: {
        NewCustomer,
        Uploader,
        ImageUploader,
        Other_attrs, MoreInfo, InputMaker, PicSelector, CitySelector, CategorySelector, TitleRibbon
    },
    props: {
        ui_schema: {
            type: Array,
            default() {
                return []
            }
        },
        fields: {
            type: Array,
            default() {
                return [];
            }
        },
        multi_time: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            newUser: null,
            moreInfo: false,
            fileCode: '',
            error:'',
            divarSave: true,
            customersDialog: false,
            schema: {
                category: "",
                location: {
                    city: "",
                    neighborhood: "",
                },
                images: [],
                other_options_and_attributes: {},
            },
            extraField: [],
            customers: [],
            customer_id: ''
        }
    },
    methods: {
        getSchema: function (value) {
            this.ui_schema = value;
        },
        getCurrent: function (value) {
            this.current = value;
        },
        getFields: function (val) {
            this.fields = val;
        },
        OpenAdd: function () {
            this.customersDialog = true
        },
        authenticate() {
            this.$modal.showLoading();
            $.ajax({
                url: `${url}/divar/check/title`,
                type: "POST",
                fn: this.authenticate,
                headers: {
                    ACCEPT: "application/json",
                    Authorization: Token,
                    "Content-type": 'application/json'
                },
                data: JSON.stringify({
                    "title": this.schema['title'],
                    "city": String(this.schema.location.city),
                    "category": this.schema.category
                }),
                msg: false,
                error: (data) => {
                    if (data.status === 422) {
                        this.$modal.error('خطا', 'لطفا اطلاعات فرم را کامل نمایید.')
                    } else {
                        this.$modal.error('خطا', 'عنوان مورد نظر قابل قبول نمی باشد.');
                    }

                },
                success: (data) => {
                    this.submitAds();
                }
            });
        },
        submitAds() {
            const data = {advertise: this.schema, customer_id: this.customer_id,identifier:this.fileCode,divarSave:this.divarSave};

            if (!this.$refs.inputs.validate() || !this.$refs.city.validate())
                return;

            if (data.advertise.location.neighborhood === "" || data.advertise.location.neighborhood === null || data.advertise.location.neighborhood === undefined)
                delete data.advertise.location.neighborhood;

            $.ajax({
                url: `${url}/user/estate`,
                method: "POST",
                fn: this.submitAds,
                headers: {
                    Authorization: Token,
                    ACCEPT: 'application/json',
                    "Content-Type": "application/json"
                },
                msg: true,
                data: JSON.stringify(data),
            });
        },
        submitWithoutMOve(){
            const data = {advertise: this.schema, customer_id: this.customer_id,identifier:this.fileCode,divarSave:this.divarSave};

            if (this.schema.category === '') {
                this.$modal.error('خطا!', 'لطفا دسته موردنظرتان را انتخاب کنید.');
                return false;
            }

            if (data.advertise.location.neighborhood === "" || data.advertise.location.neighborhood === null || data.advertise.location.neighborhood === undefined)
                delete data.advertise.location.neighborhood;

            if (!this.$refs.city.validate())
                return;

            $.ajax({
                url: `${url}/user/estate`,
                method: "POST",
                fn: this.submitAds,
                headers: {
                    Authorization: Token,
                    ACCEPT: 'application/json',
                    "Content-Type": "application/json"
                },
                msg: true,
                data: JSON.stringify(data),
            });
        },
        getCustomers() {
            Axios2.get('/user/customer/all').then((res) => {
                this.customers = res.data.data
            })
        }
    },
    watch: {
        newUser: {
            handler(value) {
                this.customers.push(value);
                this.customer_id = value.id;
                this.customersDialog=false;
            },
            deep: true
        },
        divarSave(value) {
            this.schema.send_To_divae = value;
        },
    },
    mounted() {
        this.getCustomers();
        Bus.$on('cityInfo', (value) => {
            this.schema.location.city = value.city;
            if (value.neighborhood != null || value.neighborhood !== '') {
                this.schema.location.neighborhood = value.neighborhood;
            }
        });

        Bus.$on('selectedImage', (value) => {
            this.schema.images.push(value);
        });

        Bus.$on('category-current', (current) => {
            this.schema.category = current;
        });

        Bus.$on('other_attrs', (value) => {
            this.extraField = value;
        });

        Bus.$on('rents', (value) => {
            this.schema['transformable_price'] = value;
        });
    }
}
</script>

<style scoped>

</style>